import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { LessonEntity } from '@/entities/lesson.entity';
import { UseService } from '@/services/service';
import LessonService from '@/services/lesson.service';

@Component
export default class LessonBaseMixin extends Vue {
  @Prop({ type: Number, required: true })
  lessonId: number;

  @UseService(LessonService)
  service: LessonService;

  lesson: Partial<LessonEntity> = {};

  async mounted(): Promise<void> {
    this.lesson = await this.service.getOne(this.lessonId);
  }
}
